import React, { useState } from 'react'
import { useNavigate } from 'react-router'
import { Alert, Button, ConfirmButton, Heading, Stack, Text, Box, List } from '@/components/lib'
import api from '../../../api'
import utils from '@/utils/utils'
import useStore from '../../../store'

// Builds the ready-made "Demo Study" — forms, participants, notes, data and a
// dashboard — so the platform can be explored without assembling a study by
// hand first. Anyone who can create a trial in the team can create one.
export default function Demo ({ onCreated }) {
  const [error, setError] = useState()
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const { user, team } = useStore()

  function createDemoTrial () {
    setError()
    setLoading(true)
    api.teams.createDemoTrial(user.team, ({ trial, warnings }) => {
      onCreated(trial)
      setLoading(false)
      utils.toast('success', 'Demo study created')
      for (const warning of warnings || []) utils.toast('warning', warning)
    }, err => {
      setError(err.message)
      setLoading(false)
    })
  }

  return (
    <Stack gap={5}>
      <Box>
        <Heading as='h3' size='md'>Create a demo study</Heading>
        <Text color='fg.muted'>The quickest way to see what Trialflare can do. This creates a ready-made "Demo Study" in the {team && team.name} team, already populated with:</Text>
      </Box>
      <List
        spacing={1}
        items={[
          { content: 'a screening questionnaire, a baseline questionnaire, a weekly diary and an adverse event form' },
          { content: 'ten participants across two arms and three sites, with notes and sample responses' },
          { content: 'a sample privacy statement and a dashboard' }
        ]}
      />
      <Alert variant='left-accent' status='info'>The demo study counts towards your team's trial limit. When you have finished with it, delete it from the trial's settings.</Alert>

      {error &&
        <Alert variant='left-accent' status='error'>There was a problem creating the demo study: {error}</Alert>}

      <Stack direction='row' justifyContent='end' alignItems='center'>
        <Button variant='ghost' onClick={() => navigate('/trials')}>Cancel</Button>
        <ConfirmButton
          header='Create a demo study?'
          body={`This adds a fully-populated demo trial to the ${team ? team.name : 'current'} team. It takes a few seconds.`}
          actionColor='primary'
          trigger={<Button isLoading={loading} colorPalette='primary'>Create demo study</Button>}
          onConfirm={createDemoTrial}
        />
      </Stack>
    </Stack>
  )
}
